// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningRecordId } from './CleaningRecord';
import { equipmentId } from './Equipment';
import { z } from 'zod';
export const cleaningRecordEquipment = z.object({
    cleaning_record_id: cleaningRecordId,
    equipment_id: equipmentId,
    notes: z.string().nullable(),
});
export const cleaningRecordEquipmentInitializer = z.object({
    cleaning_record_id: cleaningRecordId,
    equipment_id: equipmentId,
    notes: z.string().optional().nullable(),
});
export const cleaningRecordEquipmentMutator = z.object({
    cleaning_record_id: cleaningRecordId.optional(),
    equipment_id: equipmentId.optional(),
    notes: z.string().optional().nullable(),
});
//# sourceMappingURL=CleaningRecordEquipment.js.map